import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/crmedical/workFlow/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/crmedical/workFlow/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/crmedical/workFlow/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/crmedical/workFlow/submit', params,options)

export const update = (params, options) =>
request.post('/api/crmedical/workFlow/submit', params,options)
